import { render } from "./ContactsForm.vue?vue&type=template&id=ae4e3468&scoped=true"
import script from "./ContactsForm.vue?vue&type=script&lang=js"
export * from "./ContactsForm.vue?vue&type=script&lang=js"

import "./ContactsForm.vue?vue&type=style&index=0&id=ae4e3468&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-ae4e3468"

export default script